import qs from 'qs';
import authFetch from './fetch';
import { makeRequest, getQueryParams } from './utils';
import { CacheConfig } from './consts';
import { useQuery } from '@tanstack/react-query';

const CHASSIS_POOLS_PATH = '/api/ChassisPools';

export const getChassisPoolsGrid = (params = {}) => {
  const paramsStr = Object.keys(params).length > 0 ? `?${qs.stringify(params)}` : '';
  return authFetch
    .get(`${CHASSIS_POOLS_PATH}/Grid${paramsStr}`)
    .then(({ data: { data, total } }) => ({ data, total }));
};

export const getChassisPoolById = (id) => makeRequest(authFetch.get(`${CHASSIS_POOLS_PATH}/${id}`));

export const deleteChassisPool = (id) => makeRequest(authFetch.delete(`${CHASSIS_POOLS_PATH}/${id}`));

export const getChassisPoolsLookupUrl = (params) => `${CHASSIS_POOLS_PATH}/Lookup${getQueryParams(params)}`;
export const getChassisPoolsLookup = (params) => makeRequest(
  authFetch.get(`${CHASSIS_POOLS_PATH}/Lookup${getQueryParams(params)}`),
).then((data) => data.map((x) => ({ ...x, label: x.abbreviation, value: x.id })));
export const useGetChassisPoolsLookup = (params, opts = {}) => useQuery([getChassisPoolsLookupUrl(params)], () => getChassisPoolsLookup(params), { ...CacheConfig.forever, ...opts });

export const putChassisPool = (chassisPoolData) => makeRequest(
  authFetch.put(CHASSIS_POOLS_PATH, chassisPoolData),
);

export const getChassisPoolMembers = (id, params = {}) => makeRequest(authFetch.get(`${CHASSIS_POOLS_PATH}/${id}/members${getQueryParams(params)}`));

export const putChassisPoolMember = (id, chassisPoolData) => makeRequest(
  authFetch.put(`${CHASSIS_POOLS_PATH}/${id}/members`, chassisPoolData),
);

export const deleteChassisPoolMember = (poolId, memberId) => makeRequest(
  authFetch.delete(`${CHASSIS_POOLS_PATH}/${poolId}/members/${memberId}`),
);